/*
 * tol-school-grid.js — スクール別コレクションのタブ切替／アコーディオン開閉／グループ内ページ送り
 * （R16・LB 7-33 E-6・DECISIONS 2026-09-07（3））
 * ------------------------------------------------------------------
 * 移植元 = ../expanse_live_260831/snippets/section-main-collection-school.liquid の IIFE（:423-492）。
 * 読み込み = sections/tol-collection-grid.liquid（school_grouping = true のときだけ・defer）。
 *
 * - LIVE はルート要素に 1 回だけ addEventListener する方式。ここでは document への委譲にして、
 *   テーマエディターの section 再描画（DOM 差し替え）後もバインドし直しなしで動くようにする。
 * - 状態は hidden 属性と aria-*（selected / expanded / current）だけで持つ。fetch も pushState もしない（LIVE 同）。
 * - タブは APG タブパターンの最小構成: クリックで活性化・←→ Home End で移動＋活性化・tabindex ロービング。
 * - 二重初期化ガード = window.__tolSchoolGridInit（エディターの再描画で script が再実行されても 1 組だけ）。
 */
(function () {
  'use strict';

  /* テーマエディターの section 再描画で <script defer> が再挿入・再実行されても document リスナーを
     二重登録しない（LIVE は root.dataset.awSchoolAccordionInit で同じ事故を防いでいた・critical MINOR-A）。 */
  if (window.__tolSchoolGridInit) return;
  window.__tolSchoolGridInit = true;

  var ROOT = '[data-tol-school-grid]';

  function rootOf(el) {
    return el && el.closest ? el.closest(ROOT) : null;
  }

  function tabsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll(':scope > .tol-school-grid__tabs > [data-tol-school-tab]'));
  }

  function activateTab(root, tab) {
    var target = tab.getAttribute('data-tol-school-tab');
    tabsOf(root).forEach(function (btn) {
      var on = btn === tab;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.tabIndex = on ? 0 : -1;
    });
    Array.prototype.forEach.call(root.querySelectorAll(':scope > [data-tol-school-panel]'), function (panel) {
      var on = panel.getAttribute('data-tol-school-panel') === target;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-tol-school-tab]') : null;
    if (tab) {
      var tabRoot = rootOf(tab);
      if (tabRoot) activateTab(tabRoot, tab);
      return;
    }

    var toggle = e.target.closest ? e.target.closest('[data-tol-school-toggle]') : null;
    if (toggle && rootOf(toggle)) {
      var bodyId = toggle.getAttribute('aria-controls');
      var body = (bodyId && document.getElementById(bodyId)) || toggle.parentElement.querySelector('[data-tol-school-body]');
      if (!body) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      body.hidden = expanded;
      return;
    }

    var pageBtn = e.target.closest ? e.target.closest('[data-tol-school-pagination] [data-page]') : null;
    if (pageBtn && rootOf(pageBtn)) {
      var bar = pageBtn.closest('[data-tol-school-pagination]');
      var groupBody = bar ? bar.closest('[data-tol-school-body]') : null;
      if (!groupBody) return;
      var page = pageBtn.getAttribute('data-page');
      Array.prototype.forEach.call(bar.querySelectorAll('[data-page]'), function (btn) {
        var on = btn === pageBtn;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });
      Array.prototype.forEach.call(groupBody.querySelectorAll('[data-tol-school-card]'), function (item) {
        item.hidden = item.getAttribute('data-page') !== page;
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
    var tab = e.target && e.target.closest ? e.target.closest('[data-tol-school-tab]') : null;
    if (!tab) return;
    var root = rootOf(tab);
    if (!root) return;
    var tabs = tabsOf(root);
    var i = tabs.indexOf(tab);
    if (i < 0 || tabs.length < 2) return;
    var next = i;
    if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else next = tabs.length - 1;
    e.preventDefault();
    activateTab(root, tabs[next]);
    tabs[next].focus();
  });
})();
